import { Link } from 'react-router-dom'
import { useLandingContext } from '../../Context'
import Styled from './footer.module.css'
import { FiChevronRight } from 'react-icons/fi'
import * as Scroll from 'react-scroll';

function Footer() {
    const useContext = useLandingContext()

    return (
        <footer className={Styled.content_footer}>
            <ul>
                <h5>Menu</h5>
                <li><Scroll.Link to="inicio" smooth={true}><FiChevronRight />Inicio</Scroll.Link></li>
                <li><Scroll.Link to="curriculo" smooth={true}><FiChevronRight />Curriculo</Scroll.Link></li>
                <li><Scroll.Link to="servicos" smooth={true}><FiChevronRight />Serviços</Scroll.Link></li>
                <li><Scroll.Link to="depoimentos" smooth={true}><FiChevronRight />Depoimentos</Scroll.Link></li>
            </ul>

            <div className={Styled.container_infos}>
                <img src={useContext.websiteSettings.logo.url} alt={useContext.websiteSettings.logo.name} />
                <p>Copyright &copy;2021</p>
                <span>Desenvolvido por Fabiano Pereira</span>
            </div>


            <ul>
                <h5>Redes Sociais</h5>
                <li><Link to="#"><FiChevronRight />Blog</Link></li>
                <li><Link to="#"><FiChevronRight />Facebook</Link></li>
                <li><Link to="#"><FiChevronRight />Instagram</Link></li>
                <li><Link to="#"><FiChevronRight />Youtube</Link></li>
            </ul>
        </footer>
    )
}

export default Footer